import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új tárolási hely',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }
        ],
        searchFields: [
            {
                name: "dataManagementPlace",
                label: "Tárolási hely",
                formSize: 3,
                formType: 'text'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "dataManagementPlace",
                label: "Tárolási hely",
                sort: true,
                visibility: true,
                formType: "text",
                formSize: 6,
                formRequired: true,
                formVisible: true
            },
            {
                name: "roles",
                label: "Hozzáférési jogosultságok",
                filter: {
                    type: "simple",
                },
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllRoleApiCallback,
                    formatOption: function (val) {
                        return val.role;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'role',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                visibility: false,
                formRequired: true,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
